const model = {
    alerts: false,
    loading: false,
    error: null,
};

export default model;